// The <const> bit is imortant to be able to use this for typing later
export const screenNames = <const>{
  Login: 'LoginScreen',
  ConfirmCode: 'Verification',
  EnterInvitationCode: 'EnterInvitationCode',
  Intro: 'Intro',
  Map: 'MapView',
  MapScheduleFilter: 'MapScheduleFilter',
  MapBookForLater: 'MapBookForLater',
  SubscriptionsScreen: 'Subscriptions',
  SubscriptionDetailScreen: 'SubscriptionDetail',
  ConfirmSubscriptionDialog: 'ConfirmSubscriptionDialog',
  ConfirmSubscriptionCancelDialog: 'ConfirmSubscriptionCancelDialog',
  LockerListingScreen: 'LockerListingScreen',
  OneTimePurchaseProductsScreen: 'OneTimePurchaseProductsScreen',
  OneTimePurchaseProductDetailScreen: 'OneTimePurchaseProductDetailScreen',
  ConfirmOneTimePurchaseDialog: 'ConfirmOneTimePurchaseDialog',
  ConfirmOneTimePurchaseCancelDialog: 'ConfirmOneTimePurchaseCancelDialog',
  ReservationProductDetailScreen: 'ReservationProductDetailScreen',
  LockerReservationDetailScreen: 'LockerReservationDetailScreen',
  ConfirmReservationProductDialog: 'ConfirmReservationProductDialog',
  ConfirmReservationProductEndDialog: 'ConfirmReservationProductEndDialog',
  QRScanScreen: 'QRScanScreen',
  EnterCodeManuallyScreen: 'EnterCodeManuallyScreen',
  Signup: 'Signup',
  CompleteRegistration: 'CompleteRegistration',
  Bookings: 'Bookings',
  BookingDetail: 'BookingDetail',
  Payments: 'Payments',
  PaymentChangeBeforeCheckoutView: 'PaymentChangeBeforeCheckoutView',
  AddPaymentMethod: 'AddPaymentMethod',
  CardDetail: 'CardDetail',
  WalletDetail: 'WalletDetail',
  Help: 'Help',
  MyInfo: 'MyInfo',
  Share: 'Share',
  News: 'News',
  Home: 'Home',
  FAQ: 'FAQ',
  ToS: 'TermsOfService',
  PP: 'PrivacyPolicy',
  OSSLicense: 'OpenSourceSoftwareLicenses',
  Instructions: 'Instructions',
  ParkingTerms: 'ParkingTerms',
  OnlineSubPage: 'OnlineSubPage',
  UpdateName: 'UpdateName',
  UpdateNotifications: 'UpdateNotifications',
  UpdateUnits: 'UpdateUnits',
  UpdateContact: 'UpdateContact',
  UpdateEmail: 'UpdateEmail',
  Organisation: 'Organisation',
  UpdateOrganisation: 'UpdateOrganisation',
  ThirdPartyAuth: 'ThirdPartyAuth',
  AddThirdPartyAuth: 'AddThirdPartyAuth',
  ThirdPartyAuthWebView: 'ThirdPartyAuthWebView',
  ThirdPartyAuthDetail: 'ThirdPartyAuthDetail',
  RequestDiscount: 'RequestDiscount',
  UpdateLanguage: 'UpdateLanguage',
  AboutApp: 'AboutApp',
  AppFeedback: 'AppFeedback',
  SpaceFeedback: 'SpaceFeedback',
  WelcomeWithoutInvite: 'WelcomeWithoutInvite',
  WelcomeWithInvite: 'WelcomeWithInvite',
  AllRecentReceipts: 'AllRecentReceipts',
  CreditBalance: 'CreditBalance',
  LocationsScreen: 'LocationsScreen',
  RegionVenuesScreen: 'RegionVenuesScreen',
  SpaceInfo: 'SpaceInfo',
  SpaceDescription: 'SpaceDescription',
  SecurityDepositDialog: 'SecurityDepositDialog',
  ConfirmReservationDialog: 'ConfirmReservationDialog',
  ExtendReservationDialog: 'ExtendReservationDialog',
  EndReservationDialog: 'EndReservationDialog',
  CancelReservationDialog: 'CancelReservationDialog',
  ErrorDialog: 'ErrorDialog',
  TimezoneWarningDialog: 'TimezoneWarningDialog',
  AccountDeletion: 'AccountDeletion',
  ConfirmAccountDeletionDialog: 'ConfirmAccountDeletionDialog',
  ConfirmLogoutDialog: 'ConfirmLogoutDialog',
  ChooseStoreDialog: 'ChooseStoreDialog',
};

export const drawerScreens = <const>{
  MapStack: 'map',
  SubscriptionsStack: 'subscriptions',
  MyInfoStack: 'me',
  HelpStack: 'help',
  QRCodeStack: 'scan',
  LocationsStack: 'places',
  NewsStack: 'news',
  AdminStack: 'admin',
};
